module.exports = __webpack_public_path__ + "static/media/goal.ff849215.wav";